// TODO: Confirm if we can safely make all values lowercase
export var HttpHeader;
(function (HttpHeader) {
    HttpHeader["AUTHORIZATION"] = "Authorization";
    HttpHeader["SRCI_TRANSACTION_ID"] = "srci-transaction-id";
    HttpHeader["SRC_CLIENT_ID"] = "src-client-id";
    HttpHeader["SRC_CORRELATION_ID"] = "src-correlation-id";
    HttpHeader["SRC_DSA_ID"] = "src-dsa-id";
    HttpHeader["SRC_RECIPIENT_KEY_ID"] = "src-recipient-key-id";
    HttpHeader["SRC_RECOGNITION_TOKEN"] = "src-recognition-token";
    HttpHeader["X_SRC_CARD_TOKEN"] = "x-src-card-token";
    HttpHeader["X_SRC_CX_FLOW_ID"] = "x-src-cx-flow-id";
    HttpHeader["X_SRC_LOOKUP_TOKEN"] = "x-src-lookup-token";
    HttpHeader["X_SRC_MCID_TOKEN"] = "x-src-mcid-token";
    HttpHeader["X_SRC_NUDETECT_WIDGET_DATA"] = "x-src-nudetect-widgetdata";
    HttpHeader["X_SRC_SESSION_TOKEN"] = "X-SRC-SESSION-TOKEN";
    HttpHeader["X_SRC_TRACE_ID"] = "x-src-trace-id";
    HttpHeader["WWW_AUTHENTICATE"] = "www-authenticate";
})(HttpHeader || (HttpHeader = {}));
